export default __webpack_public_path__ + "static/media/aurous.1bf44a8d.svg";